<div class="row">
    <h1 class="titulo mb-3">Competências do candidato <span class="opcional">(opcional)</span></h1>
</div>

<mat-divider class="mb-10"></mat-divider>
<div class="row mb-5" *ngIf="!verificaRota()">
    <filterable-select [disabled]="view" class="col-12 col-md-5" [options]="competencias" optionLabel="nome"
        placeholder="Ex: Excel, Photoshop, Social media" [(selected)]="competencia"
        (onInputChanged)="onCompetenciaDigitada($event)">
    </filterable-select>

    <div class="col-12 col-md-5">
        <button [disabled]="nomeCompetencia == '' || nomeCompetencia == undefined || view" type="button"
            class="btn-adicionar" (click)="adicionarCompetencia()">Adicionar</button>
    </div>
</div>

<div class="row" *ngIf="!verificaRota()">
    <h2 class="subtitulo">Listagem de competências:</h2>
</div>

<div class="row mb-12">
    <div class="card-body table-responsive p-0">
        <table class="table text-nowrap">
            <tbody>
                <tr *ngFor="let competencia of competenciasSelect; let i = index">
                    <td class="align-middle">
                        <ng-container *ngIf="i !== indiceEdicao; else campoEdicao">
                            <span class="competencia-nome">{{ competencia?.nome }}</span>
                        </ng-container>
                        <ng-template #campoEdicao>
                            <input type="text" [(ngModel)]="competenciaEditavel.nome" class="form-control"
                                (keyup.enter)="salvarEdicao(i)" (blur)="cancelarEdicao()" />
                        </ng-template>
                    </td>

                    <td class="align-middle" *ngIf="!verificaRota()">
                        <button [title]="iconeAcaoTitulo(i)" type="button" class="btn btn-sm btn-icon btn-edit btn-xs"
                            (click)="toggleEdicao(i, competencia)" [disabled]="view">
                            <img src="../../../../assets/img/vagas/edit_vaga.svg" alt="Editar" class="icon-svg">
                        </button>

                        <button [title]="'Delete' | localize" type="button"
                            class="btn btn-sm btn-icon btn-delete btn-xs ml-3" (click)="removerCompetencia(competencia)"
                            [disabled]="view">
                            <img src="../../../../assets/img/vagas/delete_vaga.svg" alt="Deletar" class="icon-svg">
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div *ngIf="!empresaEspecial">
    <div class="row">
        <h1 class="titulo mb-3">Avaliação de requisito <span class="opcional">(opcional)</span></h1>
    </div>
    <mat-divider class="mb-10"></mat-divider>
    <div class="row mb-10">
        <div class="col-12 col-md-3" *ngIf="!verificaRota()">
            <button type="button" class="btn-adicionar" [disabled]="view"
                (click)="adicionarAvaliacaoRequisito()">Adicionar pergunta</button>
        </div>
        <div class="col-12 col-md-3">
            <button
                *ngIf="this.vaga && this.vaga.avaliacoesRequisitosVaga && this.vaga.avaliacoesRequisitosVaga.length > 0"
                type="button" class="btn-visualizar" (click)="abrirPreVisualizacao()">Pré-visualizar
                avaliação</button>
        </div>
    </div>
    <div class="row mb-5">
        <h2 class="subtitulo" *ngIf="!verificaRota()">
            Perguntas disponíveis ({{ this.vaga?.avaliacoesRequisitosVaga?.length ?? 0 }}/3):
        </h2>
    </div>

    <div *ngFor="let item of vaga?.avaliacoesRequisitosVaga; let i = index">
        <div class="avaliacao-card mb-5" *ngIf="!expandedIndex[i]" (click)="toggleExpand(i)">
            <span class="avaliacao-text">{{ item.avaliacao }}</span>
            <div class="expand-btn">
                <img src="../../../../assets/img/vagas/expande_painel.svg" alt="Expandir">
            </div>
        </div>

        <div *ngIf="expandedIndex[i]" class="avaliacao-expandida mb-5">
            <div class="avaliacao-header" (click)="toggleExpand(i)">
                <div class="avaliacao-container">
                    <span class="avaliacao-text">{{ item.avaliacao }}</span>

                    <div class="botoes-acoes" *ngIf="!verificaRota()">
                        <button type="button" class="btn btn-sm btn-icon btn-edit btn-xs"
                            (click)="editarPergunta(i, item)" [disabled]="view">
                            <img src="../../../../assets/img/vagas/edit_vaga.svg" alt="Editar" class="icon-svg">
                        </button>

                        <button type="button" class="btn btn-sm btn-icon btn-delete btn-xs" (click)="removerPergunta(i)"
                            [disabled]="view">
                            <img src="../../../../assets/img/vagas/delete_vaga.svg" alt="Deletar" class="icon-svg">
                        </button>
                    </div>
                </div>

                <div class="expand-btn">
                    <img src="../../../../assets/img/vagas/retrair_painel.svg" alt="Retrair">
                </div>
            </div>

            <div class="respostas-list">
                <div *ngFor="let resposta of item.possiveisRespostasAvaliacaoRequisito" class="resposta-item">
                    {{ resposta.resposta }}
                </div>
            </div>
        </div>
    </div>
</div>
